import { type ReactNode } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { useLanguage } from "@/contexts/LanguageContext";

interface GoogleMapsProviderProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined;

export function GoogleMapsProvider({ children, fallback = null }: GoogleMapsProviderProps) {
  const { language } = useLanguage();
  if (!API_KEY) return <>{fallback}</>;
  return <APIProvider apiKey={API_KEY} language={language}>{children}</APIProvider>;
}

export const hasGoogleMapsKey = !!API_KEY;
